export default "__VITE_ASSET__Ceb930Bq__"